module.exports = __webpack_public_path__ + "static/media/arrow-back.ae98f390.svg";